import { ScrollableDesktopContainer } from './ScrollableContainer.desktop';

export default ScrollableDesktopContainer;
